import type { ReactElement } from "react";
import { Feld } from "@kundeninfo/ui";
import { Auswahl } from "@kundeninfo/ui/me-design";

/** Die Laufzeit-Einheiten (Migration 031) — EINE Tabelle für alle Paare und die Leseansicht der Lieferverträge. Tage nur an
 *  der Kündigungsfrist eines Liefervertrags (Entscheid 544, Migration 062). */
export const TERM_UNIT_TEXT = { DAYS: "Tage", MONTHS: "Monate", YEARS: "Jahre" } as const;
export type TermUnitKey = keyof typeof TERM_UNIT_TEXT;
/** Die Einheiten eines Paares ohne eigene Liste: Monate und Jahre (Angebot, Auftrag, Mindestlaufzeit, Verlängerung). */
const MONTHS_YEARS: readonly TermUnitKey[] = ["MONTHS", "YEARS"];

/**
 * Ein Laufzeit-PAAR aus Zahl und Einheit (Migration 031) — geteilt mit der Auftragsmaske und
 * dem Vertragspanel der Lieferverträge (Final-Fixrunde Lieferanten, Teil C K5), damit alle
 * dieselben Paare zeichnen. Die Zahl ist ein `Feld` (Art `zahl`), die Einheit eine kompakte
 * `Auswahl` (Beschriftung nur für die Vorlesestimme): Zahl und Einheit stehen nebeneinander,
 * zwei Zeilen wären zwei Angaben.
 */
export function laufzeitPaar<U extends TermUnitKey = "MONTHS" | "YEARS">(arg: {
  id: string; label: string; einheitLabel: string;
  wert: string; einheit: U;
  onWert: (wert: string) => void; onEinheit: (einheit: U) => void;
  /** Die wählbaren Einheiten in dieser Folge; ohne Angabe Monate und Jahre. */
  einheiten?: readonly U[];
  fehler?: string | undefined; einheitFehler?: string | undefined;
  /** Klassenblock des Wirts (`kang`/`kauf`) — die Gestalt des Paares bleibt dort. Ein Wirt mit
   *  eigenem Raster gibt statt dessen nur die Klasse des Paares (`pairClass`, Vertragspanel). */
  block: string; pairClass?: string;
}): ReactElement {
  const einheiten = arg.einheiten ?? (MONTHS_YEARS as readonly U[]);
  const paar = (
      <div className={arg.pairClass ?? `${arg.block}__paar`}>
        <Feld id={arg.id} label={arg.label} typ="zahl" bearbeitbar wert={arg.wert}
          onChange={arg.onWert}
          {...(arg.fehler !== undefined ? { fehler: arg.fehler } : {})} />
        <Auswahl id={`${arg.id}-unit`} name={`${arg.id}-unit`} kompakt
          beschriftung={arg.einheitLabel} wert={arg.einheit}
          {...(arg.einheitFehler !== undefined ? { fehler: arg.einheitFehler } : {})}
          onGeaendert={(d) => arg.onEinheit(einheiten.find((e) => e === d.wert) ?? arg.einheit)}>
          {einheiten.map((e) => <option key={e} value={e}>{TERM_UNIT_TEXT[e]}</option>)}
        </Auswahl>
      </div>
  );
  return arg.pairClass !== undefined ? paar
    : <div className={`${arg.block}__feld ${arg.block}__feld--paar`}>{paar}</div>;
}
